import axios from 'axios'

// ==== READ

export const fetchChains = async ({ surveyId, surveyCycleKey = null } = {}) => {
  const {
    data: { list: chains },
  } = await axios.get(
    `/api/survey/${surveyId}/processing-chains`,
    surveyCycleKey ? { params: { surveyCycleKey } } : undefined
  )
  return { chains }
}

export const getChainSummaryExportUrl = ({ surveyId, chainUuid }) =>
  `/api/survey/${surveyId}/chain/${chainUuid}/summary`

// ==== CLONE

export const cloneChainFromSurvey = async ({ targetSurveyId, sourceSurveyId, sourceChainUuid }) => {
  const { data: chain } = await axios.post(`/api/survey/${targetSurveyId}/chain/clone-from-survey`, {
    sourceSurveyId,
    sourceChainUuid,
  })
  return chain
}

// ==== DELETE

export const deleteChain = async ({ surveyId, chainUuid }) => {
  await axios.delete(`/api/survey/${surveyId}/chain/${chainUuid}`)
}
